import { initializeApp, getApp, getApps } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyDvTMxMq8VTZ8YReJDMFTMOqgWHuc7cKLU",
  authDomain: "oshisha-cdadf.firebaseapp.com",
  projectId: "oshisha-cdadf",
  storageBucket: "oshisha-cdadf.firebasestorage.app",
  messagingSenderId: "209474601086",
  appId: "1:209474601086:web:48329dc9e43a4b11c9d82f",
  measurementId: "G-H2HYLYY8KZ"
};

const vapidKey = 'BP0jzowyiFmOJbseuFKHJJb9ut7X2XeB3sgWhVCasiOyCp3eqgLwNVWn_BIN_TRkF6LVNN8wJ8sBoTeC3eeey_Y';
const vapidKeyFirebase = 'BMN21EEa_yzFGJDYh1ROe__-Qd_F99UrJqjbeQpMn_hhWukg_EJPgoa3epeSjKxrXeU1xopfOQ8_MTjPpwWH-cQ';

const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

let swRegistration = null;

async function getSWRegistration() {
    const isInstalled = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (!isInstalled()) return null;

    if (swRegistration) return swRegistration;
    if (!('serviceWorker' in navigator)) return null;
    try {
        swRegistration = await navigator.serviceWorker.getRegistration('/dist/firebase-messaging-sw.js');
        if (!swRegistration) {
            swRegistration = await navigator.serviceWorker.register('/dist/firebase-messaging-sw.js', {
                type: 'module'
            });
        }
        return swRegistration;
    } catch (err) {
        console.error('SW register error:', err);
        return null;
    }
}

let firebaseMessaging = null;
const initFirebase = () => {
    const isInstalled = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (!isInstalled()) return;

    try {
        console.log('Firebase: Initializing with config...', {
            projectId: firebaseConfig.projectId,
            senderId: firebaseConfig.messagingSenderId,
            origin: window.location.origin
        });
        // Проверяем, не инициализировано ли уже приложение
        const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
        firebaseMessaging = getMessaging(app);
    } catch (err) {
        console.warn('Firebase init error:', err);
    }
};
initFirebase();

async function sendTokenToBackend(nativeSub = null, fbToken = null) {
    if (!nativeSub && !fbToken) return;

    const tokenData = nativeSub ? JSON.stringify(nativeSub) : '';
    const fbTokenData = fbToken || '';
    
    const savedNative = localStorage.getItem('pwa_native_sent');
    const savedFB = localStorage.getItem('pwa_fb_sent');

    // Если ОБА токена уже были отправлены и они совпадают с текущими, ничего не делаем
    if (savedNative === tokenData && savedFB === fbTokenData) return;

    try {
        const formData = new FormData();
        formData.append('action', 'sendPWA');
        formData.append('userAgent', navigator.userAgent);
        if (nativeSub) formData.append('jsonSubscription', tokenData);
        if (fbToken) formData.append('firebaseToken', fbTokenData);

        console.log(fbToken)
        console.log(nativeSub)
        const response = await fetch('/local/ajax/sendPWA.php', { method: 'POST', body: formData });
        if (response.ok) {
            const res = await response.text();
            if (res.trim() === 'success') {
                localStorage.setItem('pwa_native_sent', tokenData);
                localStorage.setItem('pwa_fb_sent', fbTokenData);
            }
        }
    } catch (err) {
        console.error('Send error:', err);
    }
}

async function requestAndSaveTokens(forcePermission = false) {
    const isInstalled = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (!isInstalled()) return;

    if (!('Notification' in window)) return;
    
    let permission = Notification.permission;
    if (permission === 'default' && forcePermission) {
        permission = await Notification.requestPermission();
    }
    
    if (permission !== 'granted') {
        if (permission === 'denied') {
            localStorage.setItem('pwa_push_denied_at', Date.now().toString());
        }
        return;
    }
    localStorage.removeItem('pwa_push_denied_at');

    let nativeSub = null;
    let fbToken = null;

    try {
        const reg = await getSWRegistration();
        if (reg && reg.pushManager) {
            // Ждем пока SW станет активным и готовым
            let activeWorker = reg.active;
            
            if (!activeWorker || activeWorker.state !== 'activated') {
                await new Promise((resolve) => {
                    const sw = reg.installing || reg.waiting || reg.active;
                    if (sw && sw.state === 'activated') {
                        activeWorker = sw;
                        resolve();
                    } else if (sw) {
                        const handler = (e) => {
                            if (e.target.state === 'activated') {
                                sw.removeEventListener('statechange', handler);
                                activeWorker = sw;
                                resolve();
                            }
                        };
                        sw.addEventListener('statechange', handler);
                        // Тайм-аут на случай, если что-то пошло не так
                        setTimeout(() => {
                            sw.removeEventListener('statechange', handler);
                            resolve();
                        }, 5000);
                    } else {
                        resolve();
                    }
                });
            }

            // Дополнительная проверка на наличие активного воркера перед подпиской
            if (!reg.active) {
                console.warn('No active Service Worker after waiting');
            } else {
                nativeSub = await reg.pushManager.getSubscription() || await reg.pushManager.subscribe({
                    userVisibleOnly: true,
                    applicationServerKey: urlBase64ToUint8Array(vapidKey)
                });
            }
        }
    } catch (e) { console.warn('Native sub error', e); }

    try {
        if (!firebaseMessaging) initFirebase();
        if (firebaseMessaging) {
            const reg = await getSWRegistration();
            if (reg && reg.active && reg.active.state === 'activated') {
                console.log('Firebase: Attempting to get token with VAPID key:', vapidKeyFirebase);
                fbToken = await getToken(firebaseMessaging, { 
                    vapidKey: vapidKeyFirebase,
                    serviceWorkerRegistration: reg 
                });
                console.log('Firebase: Token obtained successfully');
            } else {
                console.warn('Firebase: No active Service Worker or state not activated', reg?.active?.state);
            }
        }
    } catch (e) { 
        console.error('FB token error detail:', e);
        if (e.code === 'messaging/token-subscribe-failed') {
            console.warn('FCM subscribe failed. Check if VAPID key matches the Project ID in Firebase Console.');
        }
    }

    if (nativeSub || fbToken) {
        await sendTokenToBackend(nativeSub, fbToken);
    }
}

const initPWA = () => {
    const banner = document.getElementById('pwa-install-banner');
    const btnInstall = document.getElementById('pwa-install-btn');
    const btnClose = document.getElementById('pwa-close-btn');
    const pushBanner = document.getElementById('pwa-push-banner');
    const btnPush = document.getElementById('pwa-push-btn');
    const btnPushClose = document.getElementById('pwa-push-close-btn');

    if (!banner || !btnInstall) return;

    let deferredPrompt;
    const isInstalled = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    // Регистрация токенов и подписка должны работать ТОЛЬКО если приложение установлено и открыто как PWA
    
    window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        deferredPrompt = e;
        if (!isInstalled() && !localStorage.getItem('pwa_banner_closed')) {
            banner.style.display = 'flex';
        }
    });

    // Для iOS тоже показываем основной баннер установки, а не модалку сразу
    if (isIOS && !isInstalled() && !localStorage.getItem('pwa_banner_closed')) {
        banner.style.display = 'flex';
    }

    const safariModal = document.getElementById('pwa-safari-modal');
    const safariClose = document.getElementById('pwa-safari-close');

    if (safariModal && safariClose) {
        safariClose.addEventListener('click', () => {
            safariModal.style.display = 'none';
            localStorage.setItem('pwa_banner_closed', Date.now().toString());
        });
    }

    btnInstall.addEventListener('click', () => {
        if (isIOS) {
            // Если iOS, скрываем основной баннер и показываем инструкцию
            banner.style.display = 'none';
            if (safariModal) {
                safariModal.style.display = 'flex';
            }
        } else if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then(() => { banner.style.display = 'none'; });
        }
    });

    btnClose.addEventListener('click', () => {
        banner.style.display = 'none';
        localStorage.setItem('pwa_banner_closed', Date.now().toString());
    });

    const showPushBanner = () => {
        if (!pushBanner || Notification.permission === 'granted' || localStorage.getItem('pwa_push_banner_closed')) return;
        
        const deniedAt = localStorage.getItem('pwa_push_denied_at');
        if (deniedAt && (Date.now() - parseInt(deniedAt)) < 30 * 24 * 60 * 60 * 1000) return;

        pushBanner.style.display = 'flex';
    };

    if (btnPush) {
        btnPush.addEventListener('click', async () => {
            pushBanner.style.display = 'none';
            await requestAndSaveTokens(true);
            localStorage.setItem('pwa_push_banner_closed', Date.now().toString());
        });
    }

    if (btnPushClose) {
        btnPushClose.addEventListener('click', () => {
            pushBanner.style.display = 'none';
            localStorage.setItem('pwa_push_banner_closed', Date.now().toString());
        });
    }

    if (isInstalled()) {
        console.log('PWA: Running in standalone mode');
        if (banner) banner.style.display = 'none';
        const safariModal = document.getElementById('pwa-safari-modal');
        if (safariModal) safariModal.style.display = 'none';
        requestAndSaveTokens();
        showPushBanner();
    } else {
        console.log('PWA: Running in browser mode');
    }
};

if (isMobile) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPWA);
    else initPWA();
}
